<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'

import { BlockOnlineGamesColors } from '@kidzonet/consts/src/PolicyColors'

import IconWrapper from './BaseIcon.vue'

const theme = useTheme()

const iconColor = computed(
    () => theme.global.current.value.dark
        ? BlockOnlineGamesColors.icon.dark
        : BlockOnlineGamesColors.icon.light,
)
const backgroundColor = computed(
    () => theme.global.current.value.dark
        ? BlockOnlineGamesColors.background.dark
        : BlockOnlineGamesColors.background.light,
)
</script>

<template>
    <IconWrapper
        :style="{ backgroundColor }"
    >
        <v-icon
            icon="PolicyIconBlockOnlineGames"
            :color="iconColor"
            size="24"
        />
    </IconWrapper>
</template>
